import { useEffect, useState } from 'react';

import * as Sentry from '@sentry/react';

import { vnextApiClient } from '@/services/vnext-api';
import type { Country } from '@/types/country';

/** The seeded ISO country list, fetched once — for jurisdiction pickers. */
export function useJurisdictions(options: { enabled?: boolean } = {}) {
  const enabled = options.enabled ?? true;
  const [jurisdictions, setJurisdictions] = useState<Country[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!enabled) {
      return;
    }
    let cancelled = false;
    setIsLoading(true);
    vnextApiClient
      .listJurisdictions()
      .then((list) => {
        if (!cancelled) {
          setJurisdictions(list);
        }
      })
      .catch((err) => Sentry.captureException(err))
      .finally(() => {
        if (!cancelled) {
          setIsLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return { jurisdictions, isLoading };
}
